import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  elapsedSeconds: 0,
  isCheckedIn: false,
  checkInTime: "00:00:00",
  checkOutTime: "00:00:00",
};

const timerSlice = createSlice({
  name: "timer",
  initialState,
  reducers: {
    setElapsedSeconds: (state, action) => {
      state.elapsedSeconds = action.payload;
    },
    incrementTime: (state) => {
      if (state.isCheckedIn) {
        state.elapsedSeconds += 1;
      }
    },
    checkIn: (state) => {
      state.isCheckedIn = true;
    },
    setcheckInTime: (state, action) => {
      state.checkInTime = action.payload;
    },
    setcheckOutTime: (state, action) => {
      state.checkOutTime = action.payload;
    },
    checkOut: (state) => {
      state.isCheckedIn = false;
    },
    resetTime: (state) => {
      state.elapsedSeconds = 0;
      state.isCheckedIn = false;
      state.checkInTime = "00:00:00";
      state.checkOutTime = "00:00:00";
    },
  },
});

export const {
  setElapsedSeconds,
  incrementTime,
  checkIn,
  checkOut,
  resetTime,
  setcheckInTime,
  setcheckOutTime,
} = timerSlice.actions;

export default timerSlice.reducer;
